import { IApplicationState } from '../../types/redux';

export function getUserRole(state: IApplicationState) {
  return state.userRole;
}
